export interface Purchase {
  name: string
  city: string
  region: string
}

export const purchases: Purchase[] = [
  { name: 'Giulia M.', city: 'Milano', region: 'Lombardia, Italia' },
  { name: 'Francesca R.', city: 'Roma', region: 'Lazio, Italia' },
  { name: 'Alessia B.', city: 'Torino', region: 'Piemonte, Italia' },
  { name: 'Martina C.', city: 'Bologna', region: 'Emilia-Romagna, Italia' },
  { name: 'Chiara L.', city: 'Napoli', region: 'Campania, Italia' },
  { name: 'Sara P.', city: 'Firenze', region: 'Toscana, Italia' },
  { name: 'Valentina D.', city: 'Padova', region: 'Veneto, Italia' },
  { name: 'Federica S.', city: 'Bari', region: 'Puglia, Italia' },
  { name: 'Elena G.', city: 'Verona', region: 'Veneto, Italia' },
  { name: 'Marco T.', city: 'Genova', region: 'Liguria, Italia' },
  { name: 'Silvia A.', city: 'Palermo', region: 'Sicilia, Italia' },
  { name: 'Laura F.', city: 'Cagliari', region: 'Sardegna, Italia' },
]
